import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDevEventOverride, LazyToast, LazyLoading } from '#components'
const lazyGlobalComponents = [
  ["DevEventOverride", LazyDevEventOverride],
["Toast", LazyToast],
["Loading", LazyLoading],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
